import { useQuery } from "react-query";
import { getChamberUsers } from "src/sampleInspection/data-access/gateway";
import { useAuth } from "src/shared/context/useAuth";

function useGetChamberUsers(enabled = true) {
  const { isSystemAdmin, isGGEAdmin, isSampleInitiator } = useAuth();
  return useQuery({
    queryFn: () => {
      const isAdmin = isSystemAdmin || isGGEAdmin || isSampleInitiator;
      return getChamberUsers(isAdmin);
    },
    queryKey: ["getChamberUsers"],
    refetchOnWindowFocus: false,
    enabled,
  });
}

export default useGetChamberUsers;
